/**
 * What the chat `fetch` saw, captured before the AI SDK consumes the Response.
 * Kept as a type so call sites that build the meta stay untouched; the
 * reporting itself (Sentry/PostHog) was removed from sphinx.
 */
export type ChatResponseMeta = {
  ok: boolean;
  status: number;
  contentType?: string;
  /** Server-issued `x-request-id`. */
  requestId?: string;
  /** `x-sphinx-error-origin`, when our own route already classified the call. */
  origin?: string;
};

/**
 * Telemetry shim: chat-turn failures are no longer reported anywhere.
 * Returns whether anything was sent — always false now.
 */
export function reportChatFailure(
  _error: Error,
  _meta: ChatResponseMeta | null,
): boolean {
  return false;
}
